<ng-container *transloco="let t; read: 'history'">
  <ng-container *transloco="let tGlobal; read: 'global'">
    @if (vm$ | async; as vm) {
      <div class="componentContainer">
        <section class="xs12col componentHeader">
          <h1>{{t('title')}}</h1>
        </section>
        <!-- Template Desktop -->
        <section class="oneCol">
          <div class="xsColHidden m12col">
            <div class="boxContainer">
              <div class="box">
                <kendo-grid
                  [data]="vm.imports"
                  [skip]="vm.gridState.skip"
                  [pageSize]="vm.gridState.pageSize"
                  [pageable]="true"
                  [loading]="loading"
                  (pageChange)="pageChangeSub$.next($event)">
                  <kendo-grid-column field="createdOn" [title]="t('createdOn')">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{dataItem.createdOn | sanitizeToDateTime }}
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="createdBy" [title]="t('createdBy')">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{ dataItem.createdByFirstName }} {{ dataItem.createdByLastName }}
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="status" [title]="t('status')">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{ getStatusString(dataItem.status) }}
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="importType" [title]="t('importType')">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{ getTypeString(dataItem.importType) }}
                    </ng-template>
                  </kendo-grid-column>
                  <!-- Detail Template -->
                  <ng-template kendoGridDetailTemplate let-dataItem [kendoGridDetailTemplateShowIf]="showDetailsCondition.bind(this)">
                    <!-- Conditionally render detail content based on failedImports -->
                    <span class="fullWidth padding-top-medium padding-bottom-small fontBold">{{t('failedImports')}}</span>
                    <section class="fullWidth">
                      <table class="historyTable">
                        @for (failedImport of dataItem.failedImports; track failedImport) {
                          <tr>
                            <td>{{ failedImport.errorMessage }}, {{ getReasonString(failedImport.importFailReason) }}</td>
                          </tr>
                        }
                      </table>
                    </section>
                  </ng-template>
                  <!-- Paging -->
                  <ng-template
                    let-totalPages="totalPages"
                    let-currentPage="currentPage"
                    kendoPagerTemplate>
                    <div class="width100 flex -spaceAround -alignCenter mts">
                      <div class="flex padding-right-large">
                        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                        <kendo-pager-numeric-buttons
                          [buttonCount]="5"
                        ></kendo-pager-numeric-buttons>
                        <kendo-pager-next-buttons></kendo-pager-next-buttons>
                      </div>
                      <div class="pageSize flex align-center">
                        <kendo-buttongroup
                          [selection]="'single'"
                          id="pageBtnGroup"
                          class="-purple"
                          >
                          <button
                              (click)="
                                pageChangeSub$.next({
                                  skip: vm.gridState.skip,
                                  take: pageSizes.Small
                                })
                              "
                            kendoButton
                            [selected]="vm.gridState.pageSize === pageSizes.Small"
                            [toggleable]="true"
                            >
                            {{ pageSizes.Small }}
                          </button>
                          <button
                              (click)="
                                pageChangeSub$.next({
                                  skip: vm.gridState.skip,
                                  take: pageSizes.Medium
                                })
                              "
                            kendoButton
                            [selected]="vm.gridState.pageSize === pageSizes.Medium"
                            [toggleable]="true"
                            >
                            {{ pageSizes.Medium }}
                          </button>
                          <button
                              (click)="
                                pageChangeSub$.next({
                                  skip: vm.gridState.skip,
                                  take: pageSizes.Large
                                })
                              "
                            kendoButton
                            [selected]="vm.gridState.pageSize === pageSizes.Large"
                            [toggleable]="true"
                            >
                            {{ pageSizes.Large }}
                          </button>
                        </kendo-buttongroup>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template kendoGridNoRecordsTemplate>
                    <div class="text pl">{{t('noResults')}}</div>
                  </ng-template>
                  <ng-template kendoGridLoadingTemplate>
                    <div class="k-loading-color"></div>
                    <div class="loading-container">
                      <kendo-loader type="converging-spinner" size="large"></kendo-loader>
                    </div>
                  </ng-template>
                </kendo-grid>
              </div>
            </div>
          </div>
        </section>
        <!-- Template Smartphone -->
        <section class="oneCol">
          <div class="xs12col mColHidden">
            <div class="boxContainer">
              <div class="box">
                <kendo-grid
                  [data]="vm.imports"
                  [skip]="vm.gridState.skip"
                  [pageSize]="vm.gridState.pageSize"
                  [pageable]="true"
                  (pageChange)="pageChangeSub$.next($event)">
                  <kendo-grid-column-group >
                    <kendo-grid-column>
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <h4 class="mobileGridHeader">{{t('createdOn')}}</h4>
                        <span>{{dataItem.createdOn | sanitizeToDateTime }}</span>
                        <h4 class="mobileGridHeader">{{t('createdBy')}}</h4>
                        <span>{{ dataItem.createdByFirstName }} {{ dataItem.createdByLastName }}</span>
                        <h4 class="mobileGridHeader">{{t('status')}}</h4>
                        <span>{{ getStatusString(dataItem.status) }}</span>
                        <h4 class="mobileGridHeader">{{t('importType')}}</h4>
                        <span>{{ getTypeString(dataItem.importType) }}</span>
                      </ng-template>
                    </kendo-grid-column>
                  </kendo-grid-column-group>
                  <!-- Detail Template -->
                  <ng-template
                    kendoGridDetailTemplate
                    let-dataItem
                    [kendoGridDetailTemplateShowIf]="showDetailsCondition.bind(this)">
                    <!-- Conditionally render detail content based on failedImports -->
                    <p class="fullWidth fontBold">{{t('failedImports')}}</p>
                    <section class="fullWidth">
                      @for (failedImport of dataItem.failedImports; track failedImport) {
                        <div class="historyTableMobile">
                          <span>{{ failedImport.errorMessage }}, {{ getReasonString(failedImport.importFailReason) }}</span>
                        </div>
                      }
                    </section>
                  </ng-template>
                  <!-- Paging -->
                  <ng-template
                    let-totalPages="totalPages"
                    let-currentPage="currentPage"
                    kendoPagerTemplate
                    >
                    <div class="width100 flex -spaceAround -alignCenter mts">
                      <div class="flex padding-right-large">
                        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                        <kendo-pager-numeric-buttons
                          [buttonCount]="5"
                        ></kendo-pager-numeric-buttons>
                        <kendo-pager-next-buttons></kendo-pager-next-buttons>
                      </div>
                      <div class="pageSize flex align-center">
                        <label class="label" for="pageBtnGroup">Resultate pro Seite</label>
                        <kendo-buttongroup
                          [selection]="'single'"
                          id="pageBtnGroup"
                          class="-purple"
                          >
                          <button
                            (click)="
                              pageChangeSub$.next({
                                skip: vm.gridState.skip,
                                take: pageSizes.Small
                              })
                            "
                            kendoButton
                            [selected]="vm.gridState.pageSize === pageSizes.Small"
                            [toggleable]="true"
                            >
                            {{ pageSizes.Small }}
                          </button>
                          <button
                            (click)="
                              pageChangeSub$.next({
                                skip: vm.gridState.skip,
                                take: pageSizes.Medium
                              })
                            "
                            kendoButton
                            [selected]="vm.gridState.pageSize === pageSizes.Medium"
                            [toggleable]="true"
                            >
                            {{ pageSizes.Medium }}
                          </button>
                          <button
                            (click)="
                              pageChangeSub$.next({
                                skip: vm.gridState.skip,
                                take: pageSizes.Large
                              })
                            "
                            kendoButton
                            [selected]="vm.gridState.pageSize === pageSizes.Large"
                            [toggleable]="true"
                            >
                            {{ pageSizes.Large }}
                          </button>
                        </kendo-buttongroup>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template kendoGridNoRecordsTemplate>
                    <div class="text pl">{{t('noResults')}}</div>
                  </ng-template>
                </kendo-grid>
              </div>
            </div>
          </div>
        </section>
      </div>
    }
  </ng-container>
</ng-container>